import { defineMessages } from '@sevenrooms/locales'

export const specialAttentionMessages = defineMessages({
  header: {
    id: 'policy.details.specialAttention.header',
    defaultMessage: 'Our commitment to your safety during COVID-19',
  },
  body: {
    id: 'policy.details.specialAttention.body',
    defaultMessage:
      'Nothing is more important to us than the safety of our guests. In addition to meeting all health standards, we are taking extra precaution by ensuring that tables are spaced apart, and all surfaces are thoroughly disinfected between seatings.',
  },
})
